<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <visa-breadcrumbs :search-request="searchRequest" />
        </template>
        <template v-slot:sidebar>
            <visa-search-summary :search-request="searchRequest" search-disabled />
            <!--            <visa-order-summary-->
            <!--                :search-request="searchRequest"-->
            <!--                :offer="offer"-->
            <!--                :prepare-book-response="prepareBookResponse"-->
            <!--                :product="product"-->
            <!--            />-->
            <!--            <insurance-info-modal />-->
        </template>
    </confirmation-page-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import ConfirmationPageLayout from '@/components/parts/ConfirmationPageLayout.vue'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'
    // import InsuranceInfoModal from '@/components/insurance/info/InsuranceInfoModal.vue'
    import {VisaStoreMixin} from '~/mixins/VisaStoreMixin.vue'
    import VisaSearchSummary from '~/components/visa/search/VisaSearchSummary.vue'
    import VisaOrderSummary from '~/components/visa/booking/VisaOrderSummary.vue'
    import VisaBreadcrumbs from '~/components/visa/VisaBreadcrumbs.vue'

    @Component({
        components: {
            VisaOrderSummary,
            VisaSearchSummary,
            // InsuranceInfoModal,
            ConfirmationPageLayout,
            VisaBreadcrumbs,
        },
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class VisaConfirmationPage extends mixins(ConfirmationPageMixin, VisaStoreMixin) {
        async loadRuntimeData() {
            await useVisaRuntimeData({
                query: this.searchRequest,
            })
        }

        get basketItem() {
            return visaStore.basketItem(visaStore.prepareBookRequest.offerKey)
        }

        get offer() {
            return this.basketItem.product.offers.find(
                offer => offer.offerKey === visaStore.prepareBookRequest.offerKey
            )
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get product() {
            return this.basketItem.product
        }
    }

    export default VisaConfirmationPage
</script>
